import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Necesito ser experta en algo para vender PDFs?',
  a: "¡Para nada! Todos sabemos algo que otros necesitan. Puede ser una receta familiar, cómo organizar la casa, tips de maternidad, o cómo ahorrar en el súper. En la guía te enseño a descubrir ese 'superpoder' cotidiano."
}, {
  q: '¿Realmente puedo hacer todo desde el celular?',
  a: 'Sí, 100%. He diseñado este método pensando en mamás que no tienen tiempo de sentarse en una computadora. Escribes, diseñas (con apps gratuitas) y vendes desde tu teléfono.'
}, {
  q: '¿Cómo recibo el dinero?',
  a: 'Te enseño las formas más sencillas de cobrar, incluso si tus clientes están en otros países. Usamos plataformas seguras y fáciles de configurar.'
}, {
  q: '¿En qué formato viene el libro?',
  a: 'Es un archivo PDF digital. En cuanto haces el pago, te llega un correo para descargarlo inmediatamente a tu celular, tablet o computadora.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-white" data-id="element-26">
      <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center" data-id="element-27">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4 max-w-2xl mx-auto" data-id="element-28">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-29">
            <button className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-30">
              <span className="font-semibold text-gray-900 pr-4" data-id="element-31">{faq.q}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-32" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-33" />}
            </button>

            {openIndex === index && <div className="p-5 pt-0 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-34">
                <div className="mt-4" data-id="element-35">{faq.a}</div>
              </div>}
          </div>)}
      </div>
    </Section>;
}